import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = { rows?: number; columns: number };

export function TableSkeleton({ rows = 8, columns }: Props) {
  return Array.from({ length: rows }, (_, r) => (
    <TableRow key={`skeleton-${r}`}>
      {Array.from({ length: columns }, (__, c) => (
        <TableCell key={`skeleton-${r}-${c}`}>
          <Skeleton variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ));
}
